import './mutators/showPeoplePickerDialogMutator';
import { LazyModule, createLazyComponent, LazyImport } from 'owa-bundling';

import { ComponentClass } from 'react';
import showSharedFolderPeoplePickerDialog from './actions/showSharedFolderPeoplePickerDialog';

export { showSharedFolderPeoplePickerDialog };
export { ComponentClass };
export { default as SharedFolderPeoplePicker } from './components/SharedFolderPeoplePicker';

const lazyModule = new LazyModule(() =>
    import(/*webpackChunkName: "SharedFolderPeoplePickerDialog", webpackPrefetch: true */ './lazyIndex')
);
export let LazySharedFolderPeoplePicker = createLazyComponent(
    lazyModule,
    m => m.SharedFolderPeoplePicker
);
export let lazyShowSharedFolderPeoplePickerDialog = new LazyImport(
    lazyModule,
    m => m.showSharedFolderPeoplePickerDialog
);
